"use strict";

module.exports = {
    base: function base(model) {
        return !model.resourceUrl || /\.(dpfile|dianping|51ping|meituan|sankuai)\.(com|net)/.test(model.resourceUrl);
    },
    weixin: function weixin(model) {
        return !/(WeixinJSBridge|_WXJS|WebViewJavascriptBridge)/.test(model.sec_category);
    },
    dianping: function dianping(model) {
        return !/document.elementFromPoint/.test(model.sec_category);
    }
};